import { DropdownItem, DropdownMenu } from 'reactstrap';
import classes from './LanguageMenu.module.scss';
import LnDropDownMenu from "../LnDropDownMenu";
import languageService, { langAtom } from "../../utils/languageService";
import { useAtomValue } from "jotai";

const ManualsMenu = (props: { caretClass: string, container?: HTMLElement | string | null }) => {

    const { currentLang, languages } = useAtomValue(langAtom);


    const caretClass = [classes["caret"], props.caretClass || "white-caret"].join(" ");

    const container = props.container || "body";

    if (!currentLang) {
        return null;
    }

    return <LnDropDownMenu
        caret={false}
        toggleComponent={
            <>
                <strong className='text-white'>Manual</strong>
                <span className={caretClass}></span>
            </>
        }
        toogleClassName={ [classes["toggle"], "btn btn-minimal pointer"].join(" ")}
        toogleTagName="div"
    >
        <DropdownMenu className={classes.dropDownMenu} end container={container}>

            <DropdownItem
                className={classes.flagItem}
                tag="div"
            >
                <a href='https://static.laranara.se/manuals/author25_sv.pdf' target='_blank' rel="noopener noreferrer nofollow" >
                    <img src="/imgs/flag_sv.svg" alt="Svenska" />
                    &nbsp;Svenska
                </a>
            </DropdownItem>

            <DropdownItem
                className={classes.flagItem}
                tag="div"
            >
                <a href='https://static.laranara.se/manuals/author25_en.pdf' target='_blank' rel="noopener noreferrer nofollow" >
                    <img src="/imgs/flag_en.svg" alt="English" />
                    &nbsp;English
                </a>
            </DropdownItem>

        </DropdownMenu>
    </LnDropDownMenu>
}

export default ManualsMenu;